import React from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import './App.css' 
import Home from './pages/Home'
import axios from 'axios'
import About from './pages/About'
import Contact from './pages/Contact'
import DonateNow from './pages/DonateNow'
import DonateMon from './pages/DonateMon'
import Partners from './pages/Partners'
import OurWork from './pages/OurWork'
import OurImpact from './pages/OurImpact'
import Campaign from './pages/Campaign'
import Learn from './pages/Learn'
import Emergencies from './pages/Emergencies'
import Leadership from './pages/Leadership'
import News from './pages/News'
import Story from './pages/Story'
import ScrollToTop from './ScrollToTop'
import SEO from './SEO'

function App() {
  axios.defaults.withCredentials = true

  return (
    <>
      <SEO/>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path='/' element={<Home/>} />
            <Route path='/about-us' element={<About/>} />
            <Route path='/contact-us' element={<Contact/>} />
            <Route path='/donate-now' element={<DonateNow/>} />
            <Route path='/donate-monthly' element={<DonateMon/>} />
            <Route path='/partner-with-us' element={<Partners/>} />
            <Route path='/campaign-with-us' element={<Campaign/>} />
            <Route path='/our-work' element={<OurWork/>} />
            <Route path='/our-impact' element={<OurImpact/>} />
            <Route path='/emergencies' element={<Emergencies/>} />
            <Route path='/learn-share' element={<Learn/>} />
            <Route path='/our-leadership' element={<Leadership/>} />
            <Route path='/news' element={<News/>} />
            <Route path='/stories' element={<Story/>} />
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  )
}

export default App